import React from "react";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText = "Yes",
  cancelButtonText = "No",
}) => {
  if (!isOpen) return null;

  return (
    <div className="bg-gray-900 fixed inset-0 flex items-center justify-center bg-opacity-50">
      <div className="fixed inset-0 z-50 flex flex-col items-center justify-center">
        <div className="flex w-[440px] justify-between rounded-t-lg bg-gradient-to-r from-red-700 to-red-600 p-4">
          <p className="font-semibold text-white">{title}</p>
          <div className="cursor-pointer" onClick={onClose}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_9081_292"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_9081_292)">
                <circle
                  cx="7"
                  cy="7"
                  r="7"
                  transform="matrix(-1 0 0 1 20 5)"
                  fill="white"
                />
                <path
                  d="M12 13.4L14.9 16.3C15.0833 16.4833 15.3167 16.575 15.6 16.575C15.8833 16.575 16.1167 16.4833 16.3 16.3C16.4833 16.1167 16.575 15.8833 16.575 15.6C16.575 15.3167 16.4833 15.0833 16.3 14.9L13.4 12L16.3 9.1C16.4833 8.91667 16.575 8.68333 16.575 8.4C16.575 8.11667 16.4833 7.88333 16.3 7.7C16.1167 7.51667 15.8833 7.425 15.6 7.425C15.3167 7.425 15.0833 7.51667 14.9 7.7L12 10.6L9.1 7.7C8.91667 7.51667 8.68333 7.425 8.4 7.425C8.11667 7.425 7.88333 7.51667 7.7 7.7C7.51667 7.88333 7.425 8.11667 7.425 8.4C7.425 8.68333 7.51667 8.91667 7.7 9.1L10.6 12L7.7 14.9C7.51667 15.0833 7.425 15.3167 7.425 15.6C7.425 15.8833 7.51667 16.1167 7.7 16.3C7.88333 16.4833 8.11667 16.575 8.4 16.575C8.68333 16.575 8.91667 16.4833 9.1 16.3L12 13.4ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
                  fill="#CE2222"
                />
              </g>
            </svg>
          </div>
        </div>
        <div className="w-[440px] rounded-b-lg bg-white p-6 text-center shadow-lg">
          <div
            className="flex items-center justify-center"
            style={{
              width: "80px",
              height: "80px",
              padding: "16px",
              borderRadius: "1000px",
              background: "#FFD182",
              margin: "0 auto",
            }}
          >
            <svg
              width="81"
              height="80"
              viewBox="0 0 81 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_9136_392"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="81"
                height="80"
              >
                <rect x="0.5" width="80" height="80" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_9136_392)">
                <circle cx="41" cy="40" r="29" fill="#242424" />
                <path
                  d="M40.3327 60.0003C41.4993 60.0003 42.4855 59.5975 43.291 58.792C44.0966 57.9864 44.4993 57.0003 44.4993 55.8337C44.4993 54.667 44.0966 53.6809 43.291 52.8753C42.4855 52.0698 41.4993 51.667 40.3327 51.667C39.166 51.667 38.1799 52.0698 37.3743 52.8753C36.5688 53.6809 36.166 54.667 36.166 55.8337C36.166 57.0003 36.5688 57.9864 37.3743 58.792C38.1799 59.5975 39.166 60.0003 40.3327 60.0003ZM40.4993 73.3337C35.8882 73.3337 31.5549 72.4587 27.4993 70.7087C23.4438 68.9587 19.916 66.5837 16.916 63.5837C13.916 60.5837 11.541 57.0559 9.79102 53.0003C8.04102 48.9448 7.16602 44.6114 7.16602 40.0003C7.16602 35.3892 8.04102 31.0559 9.79102 27.0003C11.541 22.9448 13.916 19.417 16.916 16.417C19.916 13.417 23.4438 11.042 27.4993 9.29199C31.5549 7.54199 35.8882 6.66699 40.4993 6.66699C45.1105 6.66699 49.4438 7.54199 53.4993 9.29199C57.5549 11.042 61.0827 13.417 64.0827 16.417C67.0827 19.417 69.4577 22.9448 71.2077 27.0003C72.9577 31.0559 73.8327 35.3892 73.8327 40.0003C73.8327 44.6114 72.9577 48.9448 71.2077 53.0003C69.4577 57.0559 67.0827 60.5837 64.0827 63.5837C61.0827 66.5837 57.5549 68.9587 53.4993 70.7087C49.4438 72.4587 45.1105 73.3337 40.4993 73.3337ZM40.8327 25.667C42.2216 25.667 43.4299 26.1114 44.4577 27.0003C45.4855 27.8892 45.9993 29.0003 45.9993 30.3337C45.9993 31.5559 45.6243 32.6392 44.8743 33.5837C44.1243 34.5281 43.2771 35.417 42.3327 36.2503C41.0549 37.3614 39.9299 38.5837 38.9577 39.917C37.9855 41.2503 37.4993 42.7503 37.4993 44.417C37.4993 45.1948 37.791 45.8475 38.3743 46.3753C38.9577 46.9031 39.6382 47.167 40.416 47.167C41.2493 47.167 41.9577 46.8892 42.541 46.3337C43.1243 45.7781 43.4993 45.0837 43.666 44.2503C43.8882 43.0837 44.3882 42.042 45.166 41.1253C45.9438 40.2087 46.7771 39.3337 47.666 38.5003C48.9438 37.2781 50.041 35.9448 50.9577 34.5003C51.8743 33.0559 52.3327 31.4448 52.3327 29.667C52.3327 26.8337 51.1799 24.5142 48.8743 22.7087C46.5688 20.9031 43.8882 20.0003 40.8327 20.0003C38.7216 20.0003 36.7077 20.4448 34.791 21.3337C32.8743 22.2225 31.416 23.5837 30.416 25.417C30.0271 26.0837 29.9021 26.792 30.041 27.542C30.1799 28.292 30.5549 28.8614 31.166 29.2503C31.9438 29.6948 32.7493 29.8337 33.5827 29.667C34.416 29.5003 35.1105 29.0281 35.666 28.2503C36.2771 27.417 37.041 26.7781 37.9577 26.3337C38.8743 25.8892 39.8327 25.667 40.8327 25.667Z"
                  fill="#FFD182"
                />
              </g>
            </svg>
          </div>

          <p className="text-lg mt-4 font-semibold">{message}</p>
          <div className="mt-4 flex justify-between gap-3">
            <button
              onClick={onClose}
              className="btn-cancel flex-1 rounded text-white hover:bg-gray-500"
            >
              {cancelButtonText}
            </button>
            <button
              onClick={onConfirm}
              className="btn-default flex-1 rounded p-4 text-white hover:bg-blue-700"
            >
              {confirmButtonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
